<template>
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div class="fixed z-10 inset-0 overflow-y-auto" :class="showModal?'':'hidden'" aria-labelledby="modal-title"
         role="dialog" aria-modal="true">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

            <!-- This element is to trick the browser into centering the modal contents. -->
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

            <div
                style="min-height: 85vh;" class="inline-block align-bottom bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-11/12 p-1">

                <section class="p-3">
                    <div class="flex justify-between">
                        <h4 class="text-white text-sm font-bold uppercase mb-3">Media Library</h4>
                        <button type="button" class="close" @click.prevent="changeUploadBoxState"><span>×</span>
                        </button>
                    </div>
                </section>
                <div class="flex justify-around p-3">
                    <MediaLibraryLeftArea v-if="showleftarea" :fileType="this.fileType"/>

                    <div class="px-5" :class="uploadVisible ? 'w-9/12' : 'w-12/12'">
                        <MediaLibraryGrid
                            :select="select"
                            :showleftarea="showleftarea"
                            :edit="editFileInMediaLibrary"
                            :editableFile="editableFile"
                            :showModal="showModal"
                            :fileType="fileType"
                            :uploadBoxState="uploadBoxState"
                            :resetFileEditable="() => editableFile = null"
                            :mediaFilesUpdatedCount="mediaFilesUpdatedCount"
                            @upload:sidebar="val => uploadVisible = val"
                            :provider_id="provider_id"
                        />
                    </div>

                    <div v-if="uploadVisible" class="w-3/12 mb-5 px-5">
                        <MediaLibraryRightArea
                            :file="editableFile"
                            :fileType="fileType"
                            :updateMediaFiles="() => mediaFilesUpdatedCount = mediaFilesUpdatedCount + 1"
                            :showModal="showModal"
                            @upload:sidebar="val => uploadVisible = val"
                        />
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MediaLibraryGrid from '@/Pages/Media/MediaLibraryGrid.vue'
import MediaLibraryLeftArea from '@/Pages/Media/MediaLibraryLeftArea.vue'
import MediaLibraryRightArea from '@/Pages/Media/MediaLibraryRightArea.vue'

export default {
	name: 'MediaLibraryModal',
  components: {
      MediaLibraryGrid,
      MediaLibraryLeftArea,
      MediaLibraryRightArea,
  },
  props: [
    'showModal',
    'changeUploadBoxState',
    'fileType',
    'select',
    'edit',
    'uploadBoxState',
    'provider_id'
  ],
  data(){
      return{
        uploadVisible: false,
        showleftarea: false,
        editableFile: null,
        mediaFilesUpdatedCount: 0,
      }
  },
  mounted() {
      let files = [];
      if(this.provider_id > 0){
          files = this.$page.props.files[this.provider_id].data;
      } else {
          files = this.$page.props.files.data;
      }

      if(files && files.length === 0) {
          this.uploadVisible = true;
      }
  },
  methods: {
    editFileInMediaLibrary(fileId){
      const file = this.$page.props.files.data.filter(el => el.id == fileId)[0];
      this.editableFile = file;
    }
  },
  watch:{
    uploadBoxState: function(newState, oldState){
      this.editableFile = null;
    }
  }
}
</script>
